import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Star, type VariantType } from 'Components/Star';

const Stack = styled.div`
  --space: 0;

  display: flex;
  gap: var(--space);
`;

type RatingProps = {
  worst: number;
  best: number;
  score: number;
  starVariant?: VariantType;
  style?: {};
};

export const Rating = ({ best, score, starVariant, style, worst }: RatingProps) => {
  const stars = [];
  for (let i = 0; i < best; i += 1) {
    const value = score - i;
    stars.push(value >= 1 ? 100 : Math.max(0, Math.round(value * 100)));
  }

  return (
    <Stack
      className="rating"
      itemProp="reviewRating"
      itemScope
      itemType="http://schema.org/Rating"
      style={style}
    >
      <meta content={worst.toString()} itemProp="worstRating" />
      <meta content={score.toString()} itemProp="ratingValue" />
      <meta content={best.toString()} itemProp="bestRating" />
      {stars.map((fillPercent, index) => (
        <Star
          key={String(`${fillPercent}-${index}`)}
          fillBackground={theme.colors.neutral['600']}
          fillColor={theme.colors.accent['200']}
          fillPercent={fillPercent}
          variant={starVariant}
        />
      ))}
    </Stack>
  );
};
